// FryaTry — Header hamburger + mobile menu + active nav link

document.addEventListener('DOMContentLoaded', function () {

  // ---- Hamburger / mobile menu ----
  var hamburger = document.getElementById('frytry-hamburger');
  var mobileMenu = document.getElementById('frytry-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var isOpen = hamburger.classList.toggle('is-open');
      mobileMenu.classList.toggle('is-open', isOpen);
      hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });
    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!hamburger.contains(e.target) && !mobileMenu.contains(e.target)) {
        hamburger.classList.remove('is-open');
        mobileMenu.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        mobileMenu.setAttribute('aria-hidden', 'true');
      }
    });
  }

  // ---- Active nav link highlight ----
  var currentPath = window.location.pathname;
  var navLinks = document.querySelectorAll('.frytry-header__nav-link, .frytry-mobile-menu__link, .frytry-mobile-bar__item');
  navLinks.forEach(function (link) {
    var href = link.getAttribute('href');
    if (href && href !== '/' && currentPath.startsWith(href)) {
      link.style.color = 'var(--frytry-gold)';
    } else if (href === '/' && currentPath === '/') {
      link.style.color = 'var(--frytry-gold)';
    }
  });

});